<template>
  <page :setup="setup">
    <div class="bg-class">
      <video
        autoplay
        loop
        muted
        class="bgvid"
        id="bgvid"
        poster="../../asset/guide.jpg"
        style="width= 100%; height=100%; object-fit: fill"
      >
        <!-- <source src="../../asset/home.mp4" type="video/mp4" /> -->
      </video>
      <img :src="part" class="part-img" />
      <!-- <div class="bg-flex">
        <div
          v-for="(item, i) in navList"
          :key="i"
          :title="item.title || item.label"
          @click="goUrl(item.url, item.hasPermission)"
          :class="{undisable: !item.hasPermission}"
        >
          <img :src="item.icon" />
          <p>{{ item.label }}</p>
        </div>
      </div> -->
    </div>
  </page>
</template>

<script>
import isEmpty from 'lodash/isEmpty';

export default {
  data() {
    return {
      part: require('@/asset/part.png')
    };
  },
  computed: {
    navList() {
      const menus = [
        {
          url: '/wind-farm',
          icon: require('@/asset/wind.png'),
          label: '风场规划',
          // 风场未登录可以访问
          codes: []
        },
        {
          url: '/finance',
          icon: require('@/asset/finance.png'),
          label: '财务评价',
          codes: ['economicValuation']
        },
        {
          // title: '正在建设中，敬请期待',
          url: '/wind-assess',
          icon: require('@/asset/assess.png'),
          label: '风场后评估',
          codes: ['farmAssess']
        },
        {
          url: '/flow/plane',
          icon: require('@/asset/flow.png'),
          label: '流场预报',
          codes: ['globalPredict']
        },
        {
          url: '/public-database',
          icon: require('@/asset/database.png'),
          label: '机型库',
          codes: ['turbineManager', 'powerCurve', 'partManager']
        },
        {
          url: '/wind-data',
          icon: require('@/asset/wind-data.png'),
          label: '测风数据',
          codes: ['towerManager', 'dataProcess', 'windResouce', 'windWarning']
        },
        {
          url: '/typhoon',
          icon: require('@/asset/typhoon.png'),
          label: '台风轨迹',
          codes: ['typhoonPath']
        },
        {
          url: '/industry',
          icon: require('@/asset/dynamic.png'),
          label: '行业动态',
          codes: ['industryNews', 'industryManager']
        },
        {
          url: '/task/list',
          icon: require('@/asset/work.png'),
          label: '工作协同',
          codes: ['taskCreate', 'taskList', 'taskHistory', 'statisticAnalysis']
        }
      ];
      menus.forEach(menu => {
        if (isEmpty(menu.codes)) {
          menu.hasPermission = true;
          return;
        }
        if (menu.codes.some(code => this.$hasPermission(code))) {
          menu.hasPermission = true;
        }
      });
      return menus;
    }
  },
  methods: {
    async setup() {
      //console.log('setup');
    },
    goUrl(path, hasPermission) {
      if (!hasPermission) return;
      if (path === 'flow.html') {
        window.location.href = path;
      } else {
        this.$router.push(path);
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.bg-class {
  position: absolute;
  left: 0;
  right: 0;
  top: -200px;
  // top: 0;
  bottom: 0;
  background: url('../../asset/bg.png') 100% 100% no-repeat;
  background-size: auto 100%;
  overflow: hidden;
}
.part-img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.bgvid {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  // width: 100%;
  // height: 100%;
  z-index: -100;
}

.bg-flex {
  position: absolute;
  right: 40px;
  top: 200px;
  bottom: 0;
  height: 420px;
  width: 420px;
  margin: auto 0;
  display: flex;
  flex-wrap: wrap;

  .undisable {
    opacity: 0.4;
    cursor: not-allowed;
  }

  div {
    width: 140px;
    height: 140px;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
  }

  img {
    width: 60px;
    height: 60px;
    display: block;
  }

  p {
    color: #ffffff;
    font-size: 14px;
  }
}
</style>
